import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AlertIcon from '../AlertIcon';
import { formatDateTime } from '../../utils/format-time';
import { styles } from '../../styles/drawer-list-styles';
import setAlertSecondaryText from './setAlertSecondaryText';
import getIconColor from './getIconColor';

function Alert(props) {

	const [iconColor, setIconColor] = React.useState(getIconColor(props.alert.cleared));
	
	React.useEffect(() => {
		setIconColor(getIconColor(props.alert.cleared))
	}, [props.alert.cleared]);

	const handleOnClick = (e) => {
		setIconColor(getIconColor(!props.alert.cleared));
		props.handleUpdateAlert(props.alert);
	}
	const { classes } = props;
	const duration = setAlertSecondaryText(props);
	return (
		<ListItem button onClick={(e) => handleOnClick(e)}>
			<AlertIcon color={iconColor} critical={props.alert.critical} />
			<ListItemText 
				primary={formatDateTime(props.alert.time, true)}
				secondary={duration} />
		</ListItem>
	)
}

Alert.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Alert);
     


// WEBPACK FOOTER //
// ./src/components/Alert/Alert.js